import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { show_error, show_success } from "lib/helpers"

export default class extends Controller {
  static targets = ["table"]

  static values = {
    ajaxUrl: String,
  }

  connect() {
    if (!this.hasTableTarget) return
    this.element.addEventListener("click", this.boundRemoveDomain)
    this.#initDataTable()
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundRemoveDomain)
    this.#teardownModal()
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
  }

  showAddDomainModal() {
    $("#add-domain").modal("show")
  }

  boundRemoveDomain = (event) => {
    const link = event.target.closest("a[href*='remove_domain_from_list']")
    if (!link || !this.element.contains(link)) return

    event.preventDefault()
    event.stopImmediatePropagation()

    if (!window.confirm("Are you sure?")) return

    this.#submitDelete(link.href)
  }

  #teardownModal() {
    const modal = document.getElementById("add-domain")
    if (modal) $(modal).modal("hide")
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body.classList.remove("modal-open")
  }

  #initDataTable() {
    const baseUrl = this.ajaxUrlValue

    this.dataTable = createTurboDataTable(this.tableTarget, {
      dom: '<"H">rtp<"toolbar">',
      bSort: false,
      bPaginate: true,
      iDisplayLength: 10,
      stateSave: true,
      serverSide: true,
      processing: true,
      ordering: false,
      autoWidth: false,
      ajax: {
        url: baseUrl,
      },
      columnDefs: [
        {
          targets: 0,
          createdCell(cell, cellData) {
            const domainName = cellData[0]
            const notificationId = cellData[1]
            $(cell).html(
              '<div class="domain_name">' + domainName + "</div>" +
              '<a href="' + baseUrl + "/" + notificationId + '/remove_domain_from_list">' +
                '<i class="glyphicon glyphicon-trash"></i>' +
              "</a>",
            )
          },
        },
      ],
    })
  }

  #submitDelete(url) {
    const csrf = document.querySelector("meta[name='csrf-token']")?.content

    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": csrf || "",
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "same-origin",
    })
      .then((response) => {
        if (!response.ok) throw new Error("Delete failed")
        return response.json()
      })
      .then((data) => {
        this.dataTable?.ajax.reload(null, false)
        show_success(data.message)
      })
      .catch(() => {
        show_error("An error occurred during request")
      })
  }
}
